import { Stack } from '@mui/material';
import * as React from 'react';
import { FsokPaper } from '../../UIComponents/FsokPaper/FsokPaper';
import { H1 } from '../../UIComponents/H';

export interface VarderingSokContainerProps {
  heading: string;
  subheading: string;
  children: React.ReactNode;
}

export const VarderingSokLayout: React.FC<VarderingSokContainerProps> = ({
  heading,
  subheading,
  children,
}) => (
  <FsokPaper
    style={{ padding: '24px', marginTop: '16px', marginBottom: '24px' }}
  >
    <Stack direction="row">
      <H1>{heading}</H1>
      <div
        style={{
          fontFamily: 'Apex New',
          fontWeight: 400,
          color: '#888888',
          fontSize: '18px',
          paddingLeft: '8px',
        }}
      >
        {subheading}
      </div>
    </Stack>
    {children}
  </FsokPaper>
);
